"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "lg:hidden" };
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'IdCell',
    props: {
        product: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.idColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `id-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1 font-bold"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('id', 'Id', 'id_cell')), 1),
                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(__props.product.manufacturerSku), 1)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
